import React, { useEffect, useState } from "react";
import styles from "./TargetReminder.module.scss";
import moment from "moment";
import MeritoButton from "../../../../../components/common/MeritoButtons/MeritoButtons";
import { MdOutlineClose } from "react-icons/md";
import { getLocalUser } from "../../../../../components/functions/utilities";

const TargetReminder: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);
  const user = getLocalUser();
  const userId = user?.id || null;

  useEffect(() => {
    const today = moment();
    const day = today.date();
    const lastDay = today.daysInMonth();
    const monthKey = today.format("YYYY-MM");
    const storageKey = `bannerDismissed_${userId}_${monthKey}`;
    const dismissed = localStorage.getItem(storageKey);

    // Show only if between 25th and month-end, and not dismissed
    if (day >= 25 && day <= lastDay && !dismissed) {
      setShowBanner(true);
    }
  }, [userId]);

  const handleClose = () => {
    const monthKey = moment().format("YYYY-MM");
    const storageKey = `bannerDismissed_${userId}_${monthKey}`;
    localStorage.setItem(storageKey, "true");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className={styles.gradientBar}>
      <div className={styles.content}>
        <div className={styles.targetIcon}>🎯</div>
        <div>
          <div className={styles.mainText}>{`Ready for ${moment(
            new Date(),
            "DD-MM-YYYY"
          )
            .add(1, "month")
            .format("MMMM")}?`}</div>
          <div className={styles.secondaryText}>
            Add{" "}
            {moment(new Date(), "DD-MM-YYYY").add(1, "month").format("MMMM")}{" "}
            targets now and start the month with clear goals. Click on a brand
            to get started.
          </div>
        </div>
      </div>

      <MeritoButton
        type="tertiary"
        size="md"
        icon={<MdOutlineClose />}
        onlyIcon={true}
        onClick={handleClose}
      />
    </div>
  );
};

export default TargetReminder;
